import { Link as f } from "../../node_modules/@tiptap/extension-link/dist/index.mjs";
import { convertStyleObjectToCss as u } from "../../utils/style-helpers.mjs";
import { mergeAttributes as k } from "../../node_modules/@tiptap/core/dist/index.mjs";
const l = (e) => f.extend({
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      color: {
        default: e ? e.color : "rgb(17 85 204)"
      }
    };
  },
  renderHTML({ HTMLAttributes: t, mark: r }) {
    const n = {
      color: r.attrs.color,
      textDecorationLine: "underline"
    };
    return [
      "a",
      k(t, {
        style: u(n)
      }),
      0
    ];
  }
}), x = (e) => l(e).configure({
  openOnClick: !1
}), y = (e) => l(e).configure({
  HTMLAttributes: {
    rel: "noopener noreferrer"
  }
}), C = (e, t) => {
  const { state: r } = e, s = r.tr;
  let n = !1;
  r.doc.descendants((a, c) => {
    const i = c + a.nodeSize;
    a.marks.forEach((o) => {
      if (o.type.name === "link") {
        const d = o.type.create({
          ...o.attrs,
          color: t
        });
        s.removeMark(c, i, o.type).addMark(c, i, d), n = !0;
      }
    });
  }), n && e.view.dispatch(s);
};
export {
  x as createLinkExtension,
  y as createSimpleLinkExtension,
  C as updateLinkColors
};
